import React, { Component } from "react";
import Link from "../../../shared/ui/Link.Component";
import PropTypes from "prop-types";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// custom markup
import RetractableSidebar, {
  activeStyle,
} from "../../home/components/Retractable.Sidebar";
import IconWithIndicator from "../../home/components/Icon.With.Indicator";
import RefreshButton from "../../../shared/ui/Refresh.Button";
import SlideInLoader from "../../../shared/ui/SlideIn.Loader";

// icons
import RegisterIcon from "@material-ui/icons/BorderColor";
import ConfirmIcon from "@material-ui/icons/DoneAll";
import MatchIcon from "@material-ui/icons/PlaylistAddCheck";
import { accountingConnector } from "../../../services/accounting/connector";
import { compose } from "redux";

class AccountingComponent extends Component {
  timer = false;

  constructor(props) {
    super(props);

    this.state = { timerCount: 0, timerMax: 15 };
  }

  UNSAFE_componentWillMount = () => {
    this.getMatchedData();
  };

  componentWillUnmount = () => {
    this.clearIntervals();
  };

  attachIntervals = (count = 5) => {
    this.setState({ timerCount: count, timerMax: count });

    setTimeout(() => {
      this.getMatchedData();
      this.setState({ ...this.state, timerCount: 0 });
    }, count * 1000);
    this.timer = setInterval(() => {
      var timerCount =
        this.state.timerCount != 0
          ? this.state.timerCount - 1
          : clearInterval(this.timer) | 0;
      this.setState({ ...this.state, timerCount });
    }, 1000);
  };

  clearIntervals = () => {
    clearInterval(this.timer);
    this.timer = false;
  };

  getMatchedData = () => {
    this.props.getMatchedData();
  };

  render() {
    let wrapperStyle = {
      display: "flex",
      minHeight: "100%",
    };

    let matchedDepositsLength = Object.keys(
      this.props.accounting.matchedDeposits.data,
    ).length;
    let matchedInvoicesLength = Object.keys(
      this.props.accounting.matchedInvoices.data,
    ).length;
    let matchedDataLength = matchedInvoicesLength + matchedDepositsLength;

    let confirmIcon = (
      <IconWithIndicator
        icon={<ConfirmIcon />}
        displayIndicator={matchedDataLength}
        indicator={matchedDataLength}
      />
    );

    return (
      <div style={wrapperStyle}>
        <RetractableSidebar storageKey="accounting">
          <List>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"registerPayments"}
            >
              <ListItem button>
                <ListItemIcon>
                  <RegisterIcon />
                </ListItemIcon>
                <ListItemText primary="Register" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"matchPayments"}
            >
              <ListItem button>
                <ListItemIcon>
                  <MatchIcon />
                </ListItemIcon>
                <ListItemText primary="Match" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"confirmPayments"}
            >
              <ListItem button id="confirmOne">
                <ListItemIcon>{confirmIcon}</ListItemIcon>
                <ListItemText primary="Confirm" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"registerMarketplacePayments"}
            >
              <ListItem button>
                <ListItemIcon>
                  <RegisterIcon />
                </ListItemIcon>
                <ListItemText primary="Register mpl" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"registerSolvenPayments"}
            >
              <ListItem button>
                <ListItemIcon>
                  <RegisterIcon />
                </ListItemIcon>
                <ListItemText primary="Register solven " />
              </ListItem>
            </Link>
          </List>
        </RetractableSidebar>
        <div
          style={{
            width: "100%",
            boxSizing: "border-box",
            overflow: "auto",
            backgroundColor: "#f9f9f9",
          }}
        >
          <SlideInLoader open={this.state.timerCount} />
          <RefreshButton onRefreshClick={this.getMatchedData} />
          <div>
            {React.cloneElement(this.props.children, {
              ...this.props,
              attachIntervals: this.attachIntervals,
              intervalActive: !!this.state.timerCount,
            })}
          </div>
        </div>
      </div>
    );
  }
}

AccountingComponent.contextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

export default compose(accountingConnector)(AccountingComponent);
